import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.init('<ph_project_api_key>', {
    opt_out_capturing_by_default: true,
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios_swift"
        }}>{`let config = PostHogConfig(apiKey: "<ph_project_api_key>", host: "<ph_client_api_host>")
config.optOut = true
PostHogSDK.shared.setup(config)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android"
        }}>{`val config = PostHogAndroidConfig(
    apiKey = <ph_project_api_key>,
    host = <ph_client_api_host> 
)
config.optOut = true
PostHogAndroid.setup(this, config)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-react-native"
        }}>{`posthog.init('<ph_project_api_key>', {
    opt_out_capturing_by_default: true,
});
`}</code></pre>
    </MultiLanguage> 

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      